export default __webpack_public_path__ + "static/media/SpaceSaber.1f61f094.png";